import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import Swal from 'sweetalert2';
import { alertError, alertSuccess } from '../../components/Toast';
import { setData } from '../../core/redux/app/Actions';
import {
  cloneBudget,
  deletedBudget,
  generateBudgetCode,
  saveBudget,
  savePaymentTypes,
} from '../../core/utils/budget';
import {
  buildExternalUrl,
  buildWaMeUrl,
  openWhatsapp,
} from '../../core/utils/whatsapp';
import { issueExternalLink } from '../../core/utils/externalLinks';
import ModalBudget from '../../screens/ModalBudget/ModalBudget';
import { sizeIdToOption } from '../../screens/ModalBudget/utils/constants';
import { BUDGET_TABS } from '../../screens/ModalBudget/utils/enum';
import { supabase } from '../../supabaseClient';
import { useSyncBudgetVehicle } from '../../core/hooks/useSyncBudgetVehicle';
import { compareValues } from '../ModalClients/ModalClientsContainer';
import {
  calculateTotalValue,
  changeValueAeServiceFn,
  changeValueBodyshop,
  partDetails,
  partValues,
  verifyTimesExist,
} from './utils/functions';

const ModalBudgetContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const params = useParams();
  const id = location.pathname.split('/')[3];
  const isNew = params.id === '0';
  const user = useSelector((state) => state.app.user || {});
  const company = useSelector((state) => state.app.company || {});
  const reloadBudget = useSelector((state) => state.app.reloadBudget || false);
  const reloadPaymentOptions = useSelector(
    (state) => state.app.reloadPaymentOptions || false
  );
  const [values, setValues] = useState({});
  const [oldValues, setOldValues] = useState({});
  const [externalUrl, setExternalUrl] = useState(null);

  useEffect(() => {
    if (!values?.id) return undefined;
    let active = true;
    issueExternalLink('budget', values.id).then(({ data }) => {
      if (active && data?.token) {
        setExternalUrl(buildExternalUrl('budget', data.token));
      }
    });
    return () => {
      active = false;
    };
  }, [values?.id]);

  const [budget, setBudget] = useState(1);
  const [addBudget, setAddBudget] = useState(null);
  const [open, setOpen] = useState(false);
  const [hasCreated, setHasCreated] = useState(false);
  const [reloadConsultants, setReloadConsultants] = useState(false);
  const [menuOpen, setMenuOpen] = useState();
  const [client, setClient] = useState([]);
  const [clientLoading, setClientLoading] = useState(true);
  const [vehicle, setVehicle] = useState([]);
  const [vehicleLoading, setVehicleLoading] = useState(true);
  const [bodyshopService, setBodyshopService] = useState([]);
  const [bodyshopServiceVersion, setBodyshopServiceVersion] = useState(0);
  const [aeService, setAeService] = useState([]);
  const [serviceType, setServiceType] = useState([]);
  const [parts, setParts] = useState([]);
  const [part, setPart] = useState({});
  const [reload, setReload] = useState(false);
  const [hvTable, setHvTable] = useState([]);
  const [info, setInfo] = useState([]);
  const [aeInfo, setAeInfo] = useState([]);
  const [isntLinearHour, setIsntLinearHour] = useState(false);
  const [valuesBasedOnSize, setValuesBasedOnSize] = useState([]);
  const [hasInitialLength, setHasInitialLength] = useState(false);
  const [initialClientLength, setInitialClientLength] = useState(0);
  const [initialVehicleLength, setInitialVehicleLength] = useState(0);
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [reloadPrint, setReloadPrint] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [printCompany, setPrintCompany] = useState({});

  const changeValue = (field, data, value, edited = false) => {
    setReloadPrint((reload) => !reload);
    setBodyshopService((array) =>
      changeValueBodyshop({ array, field, data, value, edited })
    );
  };

  const changePartsDetail = (field, data, value) => {
    setReloadPrint((reload) => !reload);
    setParts((array) => partDetails({ array, field, data, value, part }));
  };

  const changePartsValue = (field, data, value) => {
    setReloadPrint((reload) => !reload);
    setParts((array) => partValues({ array, field, data, value }));
  };

  const changeValueAeService = (field, data, value, edited = false) => {
    setReloadPrint((reload) => !reload);
    setAeService((array) =>
      changeValueAeServiceFn({ array, field, data, value, edited })
    );
  };

  useSyncBudgetVehicle({ values, setValues, reload });


  useEffect(() => {
    if (open && !hasInitialLength && client && vehicle) {
      setInitialClientLength(client.length);
      setInitialVehicleLength(vehicle.length);
      setHasInitialLength((hasInitialLength) => hasInitialLength);
    }
  }, [open, client, vehicle]);

  useEffect(() => {
    if (
      !open &&
      vehicle.length > initialVehicleLength &&
      initialVehicleLength !== 0
    ) {
      const sortedVehicle = vehicle.sort(
        (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
      );
      const mostRecentVehicle = sortedVehicle[0];

      setValues((prevValues) => ({
        ...prevValues,
        vehicle: mostRecentVehicle,
      }));
    }
  }, [open, vehicle, initialVehicleLength]);

  useEffect(() => {
    if (
      !open &&
      (client.length > initialClientLength) & (initialClientLength !== 0)
    ) {
      const mostRecentClient = client.reduce((prev, current) => {
        const prevDate = new Date(prev.date).getTime();
        const currentDate = new Date(current.date).getTime();
        return currentDate > prevDate ? current : prev;
      });

      setValues((prevValues) => ({
        ...prevValues,
        client: mostRecentClient,
      }));
    }
  }, [open, client, initialClientLength]);

  const decidePriceBasedOnSize = async (values, info) => {
    if (values?.size) {
      let chosenSize = values?.size;

      const filteredData = info.map((item) => {
        if (chosenSize.id == 2 || chosenSize.id == '2') {
          return {
            value: item.hasOwnProperty('p_value') ? item.p_value : null,
            time: item.hasOwnProperty('p_time') ? item.p_time : null,
            title: item.title,
            id: item.id,
          };
        } else if (chosenSize.id == 3 || chosenSize.id == '3') {
          return {
            value: item.hasOwnProperty('m_value') ? item.m_value : null,
            time: item.hasOwnProperty('m_time') ? item.m_time : null,
            title: item.title,
            id: item.id,
          };
        } else if (chosenSize.id == 4 || chosenSize.id == '4') {
          return {
            value: item.hasOwnProperty('g_value') ? item.g_value : null,
            time: item.hasOwnProperty('g_time') ? item.g_time : null,
            title: item.title,
            id: item.id,
          };
        } else {
          return {};
        }
      });

      // const newValuesBasedOnSize = filteredData.filter((item) =>
      //   Object.values(item).every((value) => value !== null)
      // );
      setValuesBasedOnSize(filteredData);
    }
  };

  useEffect(() => {
    decidePriceBasedOnSize(values, info);
  }, [values?.size?.id, info]);

  // Nota:
  // Esse useEffect abaixo é responsável pelas operações envolvendo as trocas entre hora linear,
  // hora tabela, adicional sobre pintura e também valores baseados no tamanho.
  useEffect(() => {
    if (values?.percentage === undefined) {
      values.percentage = 0;
    }

    setBodyshopService((prevService) => {
      if (prevService) {
        return prevService.map((item) => {
          let updatedItem = { ...item };
          let parsedTypes;
          let tableValue;
          let matchingParsedType;
          let matchingParsedTypeValue;
          let matchingTableService;

          if (updatedItem.time === undefined) {
            updatedItem.time = '00:00';
          }

          const formatValue = (value) =>
            value && value.length >= 2 && value.substr(0, 2) === 'R$'
              ? value.substr(2)
              : value;

          const paintService =
            updatedItem?.title &&
            updatedItem?.title?.toLowerCase().includes('pintura');

          // Se FOR hora linear *ou seja, se o valor NÃO vier de alguma tabela valor-hora*
          if (
            !isntLinearHour &&
            values?.price !== undefined
            // &&
            // (values.price !== prevValues.price ||
            //   values.percentage !== prevValues.percentage)
          ) {
            const sanitizedUnitaryValue =
              values?.price && typeof values?.price === 'string'
                ? values?.price.length >= 2 &&
                  values?.price.substr(0, 2) === 'R$'
                  ? values?.price.substr(2).replace(',', '.')
                  : values?.price.replace(',', '.')
                : '';

            if (prevService) {
              if (
                paintService &&
                values?.percentage !== undefined &&
                values?.percentage !== 0
              ) {
                updatedItem.unitaryValue =
                  parseFloat(sanitizedUnitaryValue) +
                  (parseFloat(sanitizedUnitaryValue) * values?.percentage) /
                    100;
                updatedItem.time = updatedItem.time;
              } else {
                updatedItem.unitaryValue = item.editedPrice
                  ? item.unitaryValue
                  : sanitizedUnitaryValue;
                updatedItem.time = item.editedHour
                  ? item.time
                  : updatedItem.time;
              }
            } else {
              updatedItem.unitaryValue = item.editedPrice
                ? item.unitaryValue
                : updatedItem.unitaryValue;
              updatedItem.time = item.editedHour ? item.time : updatedItem.time;
            }
          } else {
            if (
              (values?.price === undefined ||
                values?.price === null ||
                values?.price === 0) &&
              (prevService.unitaryValue === undefined ||
                prevService.unitaryValue === null ||
                prevService.unitaryValue === 0)
            ) {
              updatedItem.unitaryValue = item.editedPrice
                ? item.unitaryValue
                : prevService.unitaryValue;
            } else {
              updatedItem.unitaryValue = item.editedPrice
                ? item.unitaryValue
                : updatedItem.unitaryValue;
            }
            updatedItem.time = item.editedHour ? item.time : updatedItem.time;
          }

          // Se não for hora linear *ou seja, se o valor vier de alguma tabela valor-hora*
          if (
            isntLinearHour &&
            values?.price !== undefined
            // values?.percentage !== prevvalues?.percentage
          ) {
            if (prevService) {
              tableValue = values?.price;

              if (
                typeof tableValue === 'string' &&
                tableValue.length <= 4 &&
                /^\d+$/.test(tableValue)
              ) {
                tableValue = hvTable.find(
                  (item) => item.id === Number(tableValue)
                );
              }

              parsedTypes =
                tableValue && tableValue.service_types
                  ? JSON.parse(tableValue.service_types)
                  : [];

              matchingTableService =
                updatedItem?.title &&
                updatedItem?.title?.toLowerCase().includes('pintura')
                  ? updatedItem
                  : false;

              matchingParsedType = parsedTypes.find(
                (parsedItem) => parsedItem.id === item.service_type
              );

              matchingParsedTypeValue = formatValue(matchingParsedType?.value);

              if (matchingTableService && values?.percentage !== undefined) {
                if (paintService) {
                  updatedItem.unitaryValue =
                    parseFloat(matchingParsedTypeValue) +
                    (parseFloat(matchingParsedTypeValue) * values?.percentage) /
                      100;
                } else {
                  updatedItem.unitaryValue = item.editedPrice
                    ? item.unitaryValue
                    : parseFloat(matchingParsedTypeValue);
                }
              } else {
                const loadedUnitaryValue = (
                  matchingParsedTypeValue ?? ''
                ).replace(',', '.');
                updatedItem.unitaryValue = item.editedPrice
                  ? item.unitaryValue
                  : parseFloat(loadedUnitaryValue);
              }
            } else {
              updatedItem.unitaryValue = item.editedPrice
                ? item.unitaryValue
                : updatedItem.unitaryValue;
            }
            updatedItem.unitaryValue = item.editedPrice
              ? item.unitaryValue
              : updatedItem.unitaryValue;
            updatedItem.time = item.editedHour ? item.time : updatedItem.time;
          }

          // Caso haja algum item com a classificação de serviço como PINTURA, pra aplicar
          // o adicional sobre pintura. Além disso, também adiciona o valor e tempo baseado no tamanho escolhido.
          if (
            values?.price === undefined ||
            values?.price == 0 ||
            values?.price == 'R$'
          ) {
            if (prevService) {
              if (paintService) {
                if (valuesBasedOnSize.length > 0) {
                  for (let i = 0; i < valuesBasedOnSize.length; i++) {
                    if (
                      valuesBasedOnSize[i].value >= 0 &&
                      valuesBasedOnSize[i].time !== 0 &&
                      valuesBasedOnSize[i].title === updatedItem.title
                    ) {
                      updatedItem.unitaryValue =
                        parseFloat(valuesBasedOnSize[i].value) +
                        (parseFloat(valuesBasedOnSize[i].value) *
                          values?.percentage) /
                          100;
                      updatedItem.time = valuesBasedOnSize[i].time;
                    } else {
                      updatedItem.unitaryValue = item.editedPrice
                        ? item.unitaryValue
                        : updatedItem.unitaryValue;
                      updatedItem.time = item.editedHour
                        ? item.time
                        : updatedItem.time;
                    }
                  }
                } else {
                  updatedItem.unitaryValue = item.editedPrice
                    ? item.unitaryValue
                    : updatedItem.unitaryValue;
                  updatedItem.time = item.editedHour
                    ? item.time
                    : updatedItem.time;
                }
              } else {
                for (let i = 0; i < valuesBasedOnSize.length; i++) {
                  if (
                    valuesBasedOnSize[i].value >= 0 &&
                    valuesBasedOnSize[i].time !== 0 &&
                    valuesBasedOnSize[i].title === updatedItem.title
                  ) {
                    updatedItem.unitaryValue = item.editedPrice
                      ? item.unitaryValue
                      : valuesBasedOnSize[i].value;
                    updatedItem.time = item.editedHour
                      ? item.time
                      : valuesBasedOnSize[i].time;
                  } else {
                    updatedItem.unitaryValue = item.editedPrice
                      ? item.unitaryValue
                      : updatedItem.unitaryValue;
                    updatedItem.time = item.editedHour
                      ? item.time
                      : updatedItem.time;
                  }
                }
              }
            }
          } else {
            for (let i = 0; i < valuesBasedOnSize.length; i++) {
              if (
                valuesBasedOnSize[i].value >= 0 &&
                valuesBasedOnSize[i].time !== 0 &&
                valuesBasedOnSize[i].title === updatedItem.title
              ) {
                // updatedItem.unitaryValue = valuesBasedOnSize[i].value
                updatedItem.time = item.editedHour
                  ? item.time
                  : valuesBasedOnSize[i].time;
              } else {
                updatedItem.unitaryValue = item.editedPrice
                  ? item.unitaryValue
                  : updatedItem.unitaryValue;
                updatedItem.time = item.editedHour
                  ? item.time
                  : updatedItem.time;
              }
            }
          }

          updatedItem.value = calculateTotalValue(
            updatedItem.time,
            typeof updatedItem?.unitaryValue === 'string'
              ? updatedItem?.unitaryValue?.replace(',', '.')
              : updatedItem.unitaryValue
          );

          return updatedItem;
        });
      }
    }, []);
  }, [values?.price, values?.percentage, valuesBasedOnSize, isntLinearHour, hvTable, bodyshopServiceVersion]);

  useEffect(() => {
    loadHourlyValue();
  }, [company]);
  useEffect(() => {
    if (id !== '0') {
      loadData();
    }
  }, [id]);

  useEffect(() => {
    loadClient();
  }, [company.id, reload]);

  // Recarrega dados quando o cliente é editado
  useEffect(() => {
    const reloadClientData = async () => {
      // Recarrega a lista de clientes
      await loadClient();

      // Atualiza os dados do cliente selecionado
      if (values?.client) {
        const clientId = values.client.value || values.client;

        // Busca os dados atualizados do cliente
        const { data: clientData, error } = await supabase
          .from('Client')
          .select('*, Vehicle(responsible, *), Origin(id, *)')
          .eq('id', clientId)
          .is('deleted_at', null)
          .single();

        if (!error && clientData) {
          // Atualiza apenas com os campos necessários, evitando objetos problemáticos
          setValues(prev => ({
            ...prev,
            client: {
              value: clientData.id,
              label: clientData.name,
              // Campos essenciais do cliente
              id: clientData.id,
              name: clientData.name,
              cellphone: clientData.cellphone,
              telephone: clientData.telephone,
              email: clientData.email,
              cpf: clientData.cpf,
              cnpj: clientData.cnpj,
              rg: clientData.rg,
              birthday: clientData.birthday,
              cep: clientData.cep,
              street: clientData.street,
              number: clientData.number,
              complement: clientData.complement,
              neighborhood: clientData.neighborhood,
              city: clientData.city,
              state: clientData.state,
              countrie: clientData.countrie,
              observation: clientData.observation,
              person: clientData.person,
              origin: clientData.origin,
              Vehicle: clientData.Vehicle,
              Origin: clientData.Origin
            },
            client_name: clientData.name
          }));
        }
      }
    };

    reloadClientData();
  }, [reloadBudget]);

  useEffect(() => {
    loadServices();
    loadAestheticServices();
  }, [company]);

  const loadServices = async () => {
    let { data, error } = await supabase
      .from('Services')
      .select('*')
      .eq('id_company', company.id)
      .is('deleted_at', null);
    if (!error) {
      getServiceTable(data);
    }
  };

  const loadAestheticServices = async () => {
    let { data, error } = await supabase
      .from('AestheticServices')
      .select('*')
      .eq('id_company', company.id)
      .is('deleted_at', null);
    if (!error) {
      getAestheticServiceTable(data);
    }
  };

  const getServiceTable = async (data) => {
    const dataFormatter =
      values?.price && values?.price.service_types
        ? JSON.parse(values?.price.service_types)
        : [];

    const newData = data.map((item) =>
      item.service_type === budget
        ? {
            ...item,
            unitaryValue: dataFormatter?.find((item) => item.id === budget)
              ?.value,
          }
        : item
    );

    setInfo(newData);
  };

  const getAestheticServiceTable = async (data) => {
    const dataFormatter =
      values?.price && values?.price.service_types
        ? JSON.parse(values?.price.service_types)
        : [];

    const newData = data.map((item) =>
      item.service_type === budget
        ? {
            ...item,
            unitaryValue: dataFormatter?.find((item) => item.id === budget)
              ?.value,
          }
        : item
    );

    setAeInfo(newData);
  };

  const loadHourlyValue = async () => {
    let { data, error } = await supabase
      .from('HourlyValue')
      .select('*')
      .eq('id_company', company.id)
      .is('deleted_at', null);
    if (!error) {
      setHvTable(
        data.map((item) => ({ ...item, label: item.title, value: item.id }))
      );
    }
  };

  const showBudgetItems = (id, budget = false, items) => {
    if (budget) {
      const budgetFilter = addBudget || [];
      setAddBudget(
        budgetFilter.filter((item) => item.id === id).length > 0
          ? budgetFilter.filter((item) => item.id !== id)
          : budgetFilter.concat(items)
      );
    } else {
      setBudget(id);
    }
  };

  const loadData = async () => {
    let { data, error } = await supabase
      .from('Budget')
      .select(
        `
        *,
        client_name:Client(name),
        Vehicle(responsible, *)
        `
      )
      .eq('id', id)
      .is('deleted_at', null);
    if (!error) {
      const valuesSize = () => sizeIdToOption(data?.[0]?.size);
      setValues({
        ...data[0],
        client_name: data?.[0]?.client_name?.name,
        size: valuesSize(),
        image_checklist: JSON.parse(data[0]?.image_checklist || '[]'),
        id_consultant: data[0]?.id_consultant,
        bodyshop_discount: data[0]?.bodyshop_discount || 0,
        aesthetics_discount: data[0]?.aesthetics_discount || 0,
        parts_discount: data[0]?.parts_discount || 0,
      });
      setIsntLinearHour(data[0]?.hour);
      setOldValues(data[0]);
      setBodyshopService(JSON.parse(data[0]?.service) || []);
      setAeService(
        JSON.parse(data[0]?.ae_service)?.map((item) => ({
          ...item,
          unitaryValue: item.unitaryValue || item.p_value,
          quantity: item.quantity || 1,
        })) || []
      );
      setParts(JSON.parse(data[0]?.parts) || []);
    }
  };

  useEffect(() => {
    if (id === '0') {
      loadCompany();
    }
  }, [id]);

  useEffect(() => {
    if (id === '0') {
      setValues((values) => ({
        ...values,
        observation: printCompany.budgetNote,
        percentage: values?.percentage ? values?.percentage : 0,
        size: values?.size?.value
          ? values?.size
          : { id: 3, value: 'M', label: 'M' },
        status: values?.status?.values
          ? values?.status
          : {
              id: 4,
              value: 'Pendente',
              label: 'Pendente',
              color: '#b36a22',
            },
      }));
      setOldValues((values) => ({
        ...values,
        observation: printCompany.budgetNote,
        percentage: values?.percentage ? values?.percentage : 0,
        size: values?.size?.value
          ? values?.size
          : { id: 3, value: 'M', label: 'M' },
        status: values?.status?.values
          ? values?.status
          : {
              id: 4,
              value: 'Pendente',
              label: 'Pendente',
              color: '#b36a22',
            },
      }));
    }
  }, [id, printCompany?.budgetNote, company]);

  useEffect(() => {
    loadVehicleNoClient();
  }, [values?.client?.value || values?.client, reload]);

  const addedParts =
    values?.parts !== undefined ? JSON.parse(values?.parts) : undefined;

  const addedServices = values?.service
    ? JSON.parse(values?.service)
    : undefined;

  const closeModal = () => {
    if (compareValues(oldValues, values)) {
      Swal.fire({
        title: 'Deseja sair sem salvar?',
        showCancelButton: true,
        showConfirmButton: false,
        showDenyButton: true,
        icon: 'warning',
        text: 'Ao sair, seus dados seram descartados.',
        denyButtonText: `Sair`,
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isDenied) {
          history.push('/budgets');
        }
      });
    } else {
      history.push('/budgets');
    }
  };

  const onClone = async () => {
    if (!values?.id) return;

    const hasUnsavedChanges = compareValues(oldValues, {
      ...values,
      parts: JSON.stringify(parts || []),
      service: JSON.stringify(bodyshopService || []),
      ae_service: JSON.stringify(aeService || []),
    });

    if (hasUnsavedChanges) {
      const result = await Swal.fire({
        title: 'Salve as alterações antes de clonar',
        text: 'Para clonar este orçamento, é necessário salvar as alterações pendentes.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Salvar e Clonar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;
      await onSave();
    } else {
      const result = await Swal.fire({
        title: 'Deseja clonar este orçamento?',
        text: 'Uma cópia idêntica será criada e aberta.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Clonar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;
    }

    const { data, error } = await cloneBudget(values.id, company.id);

    if (error || !data?.[0]) {
      alertError('Erro ao clonar orçamento');
      return;
    }

    alertSuccess('Orçamento clonado com sucesso!');
    dispatch(setData({ reloadBudget: Date.now() }));
    history.replace(`/budgets/details/${data[0].id}`);
  };

  const loadClient = async () => {
    setClientLoading(true);
    try {
      // Paginação para buscar todos os clientes
      let allData = [];
      const pageSize = 1000;
      let page = 0;
      let hasMore = true;

      while (hasMore) {
        const from = page * pageSize;
        const to = from + pageSize - 1;

        // Projeta só os campos que o setClient.map abaixo consome — sem JOINs
        // Vehicle/Origin descartados, sem `*`. Reduz drasticamente o payload em
        // empresas com muitos clientes/veículos. Detalhes completos do cliente
        // são buscados sob demanda em reloadClientData (.eq('id', id).single()).
        let { data: pageData, error } = await supabase
          .from('Client')
          .select('id, name, created_at, cnpj, cpf, telephone, cellphone')
          .eq('id_company', company.id)
          .is('deleted_at', null)
          .range(from, to)
          .order('name', { ascending: true });

        if (error) break;

        if (pageData && pageData.length > 0) {
          allData = [...allData, ...pageData];
        }

        hasMore = pageData && pageData.length === pageSize;
        page++;
      }

      setClient(
        allData.map((item) => ({
          label: item.name,
          value: item.id,
          date: item.created_at,
          cnpj: item.cnpj,
          cpf: item.cpf,
          telephone: item.telephone,
          cellphone: item.cellphone,
        }))
      );
    } finally {
      setClientLoading(false);
    }
  };

  const loadVehicleNoClient = async () => {
    setVehicleLoading(true);
    try {
      let allData = [];
      let from = 0;
      const pageSize = 1000;
      let hasMore = true;

      while (hasMore) {
        // Projeta só o que o setVehicle.map abaixo consome.
        const { data, error } = await supabase
          .from('Vehicle')
          .select('id, plate, model, created_at')
          .is('deleted_at', null)
          .eq('company', company.id)
          .range(from, from + pageSize - 1);

        if (error) {
          console.error('Error loading vehicles:', error);
          break;
        }

        if (data && data.length > 0) {
          allData = [...allData, ...data];
          from += pageSize;
          hasMore = data.length === pageSize;
        } else {
          hasMore = false;
        }
      }

      setVehicle(
        allData.map((item) => ({
          label: `${item.plate} / (${item.model})`,
          value: item.id,
          date: item.created_at,
        }))
      );
    } finally {
      setVehicleLoading(false);
    }
  };

  useEffect(() => {
    loadCompany();
  }, []);

  const loadCompany = async () => {
    let { data, error } = await supabase
      .from('Company')
      .select('*')
      .eq('id', company.id)
      .is('deleted_at', null);

    if (!error) {
      setPrintCompany(data[0]);
    } else {
      console.log(error);
    }
  };

  const onSave = async (functionPrint = undefined) => {
    const newBudgetCode = await generateBudgetCode(company.id);

    try {
      delete values.Vehicle;

      if (values && !values.client) {
        alertError('Cliente é obrigatório');
        return;
      }

      if (values && !values.vehicle) {
        alertError('Veículo é obrigatório');
        return;
      }

      if (values && !values.size) {
        alertError('Tamanho é obrigatório');
        return;
      }

      if (values && !values.status) {
        alertError('Status é obrigatório');
        return;
      }

      if (!verifyTimesExist(bodyshopService)) {
        setBudget(BUDGET_TABS.BODYSHOP);
        alertError('Campo de horas com valor zerado');
        return;
      }

      // Criar consultor se for novo (value = '0' ou string) antes de salvar o orçamento
      let consultantId = values?.id_consultant?.value || values?.id_consultant;

      if (
        values?.id_consultant &&
        (values.id_consultant.value === '0' ||
          values.id_consultant.value === 0 ||
          (typeof values.id_consultant === 'object' &&
            !Number.isInteger(values.id_consultant.value)))
      ) {
        try {
          const { data: consultantData, error: consultantError } =
            await supabase
              .from('CompanyConsultant')
              .insert([
                {
                  name: values.id_consultant.label,
                  company_id: company.id,
                },
              ])
              .select('*');

          if (!consultantError && consultantData?.[0]) {
            consultantId = consultantData[0].id;
            alertSuccess('Consultor criado com sucesso!');
            setReloadConsultants((prev) => !prev);

            // Atualizar o valor no state para evitar criar novamente
            setValues((prevValues) => ({
              ...prevValues,
              id_consultant: {
                label: consultantData[0].name,
                value: consultantData[0].id,
              },
            }));
          } else {
            alertError('Erro ao criar consultor');
            return;
          }
        } catch (error) {
          console.error('Erro ao criar consultor:', error);
          alertError('Erro ao criar consultor');
          return;
        }
      }

      const saveResult = await saveBudget(values?.id, {
        ...values,
        created_at: dateWithoutTimezone(new Date()),
        code: values && values.code ? values.code : newBudgetCode,
        payment:
          (values && values.payment && values.payment.id) || values.payment,
        size: (values && values.size && values.size.id) || values.size,
        status: (values && values.status && values.status.id) || values.status,
        hour: (values && values?.hour) || values?.hour,
        price: values?.hour
          ? typeof values?.price === 'object'
            ? values?.price.id || 0
            : typeof values?.price === 'string'
            ? parseFloat(
                values?.price.replace('R$', '').replace(',', '.').trim()
              ) || 0
            : values?.price || 0
          : typeof values?.price === 'string'
          ? parseFloat(
              values?.price.replace('R$', '').replace(',', '.').trim()
            ) || 0
          : values?.price || 0,
        client:
          (values && values.client && values.client.value) || values.client,
        client_name:
          (values && values.client && values.client.label) ||
          values.client_name,
        id_company: company.id,
        vehicle:
          (values && values.vehicle && values.vehicle.value) || values.vehicle,
        vehicle_name:
          (values && values.vehicle && values.vehicle.label) ||
          values.vehicle_name,
        service: JSON.stringify(
          bodyshopService.map((item, index) => ({ ...item, id: index })) || []
        ),
        parts: JSON.stringify(
          parts.map((item, index) => ({ ...item, id: index })) || []
        ),
        ae_service: JSON.stringify(
          aeService.map((item, index) => ({ ...item, id: index })) || []
        ),
        image_checklist: JSON.stringify(values?.image_checklist || []),
        id_consultant: consultantId,
        bodyshop_discount: values?.bodyshop_discount || 0,
        aesthetics_discount: values?.aesthetics_discount || 0,
        parts_discount: values?.parts_discount || 0,
      });
      const { error, data } = saveResult;
      if (!error) {
        alertSuccess('Sucesso ao salvar o orçamento!');
        history.push(`/budgets/details/${data[0].id}`);
        dispatch(setData({ reloadBudget: !reloadBudget }));

        // setValues(data[0]);
        // setOldValues(data[0]);
        if (functionPrint) {
          functionPrint(); // check this l8r
        }
      } else {
        alertError('Erro ao salvar o orçamento, tente novamente mais tarde.');
      }
    } catch (error) {
      alertError('Erro ao salvar o orçamento, tente novamente mais tarde.');
    }

    if (hasCreated !== false) {
      try {
        const savePayment = await savePaymentTypes({
          id_company: company.id,
          payment_type: values.payment,
        });

        const { error, data } = savePayment;
        if (!error) {
          alertSuccess('Sucesso ao salvar a opção de pagamento!');
          dispatch(setData({ reloadPaymentOptions: !reloadPaymentOptions }));
          setHasCreated(false);
        } else {
          alertError(
            'Erro ao salvar a opção de pagamento, tente novamente mais tarde.'
          );
        }
      } catch (error) {
        alertError(
          'Erro ao salvar a opção de pagamento, tente novamente mais tarde.'
        );
      }
    }
  };

  const onChange = (field, value) => {
    setReloadPrint((reload) => !reload);
    setValues((values) => ({ ...values, [field]: value }));
  };

  const onRemove = async () => {
    const confirmation = await Swal.fire({
      title: 'Deseja mesmo excluir?',
      showCancelButton: true,
      showConfirmButton: false,
      showDenyButton: true,
      icon: 'warning',
      text: 'Seus dados serão completamente perdidos!',
      denyButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
    });

    if (confirmation.isDenied) {
      if (values && values.id) {
        const { data, error } = await deletedBudget(values.id, user.id);

        if (!error) {
          alertSuccess('Orçamento removido com sucesso!');
          history.push('/budgets');
          dispatch(setData({ reloadBudget: !reloadBudget }));
        } else {
          alertError('Erro ao remover o cliente, tente novamente mais tarde');
        }
      } else {
        alertError('Erro ao remover o cliente, tente novamente mais tarde');
      }
    } else {
      history.push('/budgets');
    }
  };

  const createOption = async (name, field) => {
    setReloadPrint((reload) => !reload);
    setValues((values) => ({
      ...values,
      [field]: { label: name, value: '0' },
    }));

    setHasCreated((hasCreated) => !hasCreated);
  };

  const onRemovePiece = (data) => {
    setReloadPrint((reload) => !reload);
    setParts((oldParts) => oldParts.filter((part) => part.id !== data.id));
  };
  const onRemoveService = (data) => {
    setReloadPrint((reload) => !reload);
    setBodyshopService((oldServices) =>
      oldServices.filter((service) => service.id !== data.id)
    );
  };
  const onRemoveAeService = (data) => {
    setReloadPrint((reload) => !reload);
    setAeService((oldAeServices) =>
      oldAeServices.filter((aeService) => aeService.id !== data.id)
    );
  };

  const sendWhatsapp = async () => {
    const clientId = values?.client?.value || values?.client;
    const clientName = values?.client?.label || values?.client_name;
    const clientVehicle = values?.Vehicle?.model;
    const veiculo = values?.vehicle_name
      ? values.vehicle_name.split(' / ')[1]
      : '';

    const matchingClient = client.find((item) => item.value === clientId);
    let cellphone = matchingClient?.cellphone || values?.client?.cellphone;

    if (!cellphone && clientId) {
      const { data: freshClient } = await supabase
        .from('Client')
        .select('cellphone')
        .eq('id', clientId)
        .is('deleted_at', null)
        .single();
      cellphone = freshClient?.cellphone;
    }

    if (!cellphone) {
      alertError('Cliente não possui telefone cadastrado.');
      return;
    }

    const budgetId = values.id;
    let fullUrl = externalUrl;
    if (!fullUrl) {
      const { data, error } = await issueExternalLink('budget', budgetId);
      if (error || !data?.token) {
        alertError('Erro ao gerar o link do orçamento. Tente novamente.');
        return;
      }
      fullUrl = buildExternalUrl('budget', data.token);
    }
    const message = `Olá ${clientName}, somos da empresa ${
      company?.tradingName
    }.\nSegue o link do orçamento do seu veículo ${
      clientVehicle || veiculo
    }, para aprovar, basta entrar abaixo e aceitar!\n${fullUrl}`;
    const whatsappUrl = buildWaMeUrl({ phone: cellphone, message });

    // Navega ANTES dos side effects para preservar a "transient user activation"
    // — sem isso, o universal link do WhatsApp não dispara o app no mobile.
    openWhatsapp(whatsappUrl);

    setValues(() => ({
      ...values,
      status: values?.status?.values
        ? values?.status
        : {
            id: 2,
            value: 'Enviado',
            label: 'Enviado',
            color: '#b5b5b5',
          },
    }));

    if (values?.shared_at === null) {
      // shared_at é metadado interno; falha aqui não afeta o envio em si.
      saveBudget(budgetId, { shared_at: new Date() }).catch((err) => {
        console.warn('Falha ao registrar shared_at do orçamento:', err);
      });
    }
  };

  const onChangePiece = (field, value) => {
    setPart((part) => ({ ...part, [field]: value }));
  };

  const openEditModal = (item) => {
    setIsOpen(5);
    setPart({
      ...item,
      profit: item?.profit ? item.profit : undefined,
      discount: item?.discount ? item.discount : undefined,
      gross_price: item?.value,
      images: item?.images?.images
        ? JSON.parse(item?.images?.images)
        : item?.images
        ? ''
        : '',
    });
  };

  const deleteOptions = async (id, e) => {
    e.preventDefault();
    e.stopPropagation();
    // setPaymentOptions(paymentOptions.filter(options => options.id !== id))
    const { data, error } = await supabase
      .from('PaymentTypes')
      .update({ deleted_at: new Date() })
      .eq('id', id);

    if (!error) {
      setPaymentOptions(
        paymentOptions.filter((options) => options.id !== parseInt(id))
      );
      alertSuccess('Deletado com sucesso');
    }
  };

  const divCreatable = (data, e) => {
    if (data.id) {
      e.preventDefault();
      onChange('payment', { label: data.label, value: data.id });
    } else {
      setValues((values) => ({
        ...values,
        payment: { label: data.value, value: '0' },
      }));
      setHasCreated((hasCreated) => !hasCreated);
    }
    setReloadPrint((reload) => !reload);
    e.type === 'click' ? setMenuOpen(false) : null;
  };

  const creatableOpen = (e) => {
    if (e.target.id === 'react-select-6-input') {
      setMenuOpen(true);
    } else if (e.target.id === 'path') {
      setMenuOpen(true);
    }
  };

  return (
    <ModalBudget
      setHasCreated={setHasCreated}
      setOldValues={setOldValues}
      setReloadPrint={setReloadPrint}
      setValues={setValues}
      reloadConsultants={reloadConsultants}
      reloadPaymentOptions={reloadPaymentOptions}
      compareValues={
        isNew
          ? compareValues({ oldValues }, { values })
          : compareValues(oldValues, {
              ...values,
              parts: JSON.stringify(parts || []),
              service: JSON.stringify(bodyshopService || []),
              ae_service: JSON.stringify(aeService || []),
            })
      }
      isNewValue={compareValues(values, oldValues, {
        ...values,
        parts: JSON.stringify(parts || []),
        service: JSON.stringify(bodyshopService || []),
        ae_service: JSON.stringify(aeService || []),
      })}
      creatableOpen={creatableOpen}
      menuOpen={menuOpen}
      divCreatable={divCreatable}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      openEditModal={openEditModal}
      onChangePiece={onChangePiece}
      part={part}
      setPart={setPart}
      company={company}
      printCompany={printCompany}
      reloadPrint={reloadPrint}
      addedParts={addedParts}
      calculateTotalValue={calculateTotalValue}
      valuesBasedOnSize={valuesBasedOnSize}
      changeValue={changeValue}
      changePartsValue={changePartsValue}
      changePartsDetail={changePartsDetail}
      addedServices={addedServices}
      serviceType={serviceType}
      setServiceType={setServiceType}
      setAddBudget={setAddBudget}
      isntLinearHour={isntLinearHour}
      setIsntLinearHour={setIsntLinearHour}
      closeModal={closeModal}
      onClone={onClone}
      onChange={onChange}
      values={values}
      isNew={isNew}
      onSave={onSave}
      paymentOptions={paymentOptions}
      setPaymentOptions={setPaymentOptions}
      sendWhatsapp={sendWhatsapp}
      client={client}
      clientLoading={clientLoading}
      setClient={setClient}
      vehicle={vehicle}
      vehicleLoading={vehicleLoading}
      setVehicle={setVehicle}
      budget={budget}
      open={open}
      addBudget={addBudget}
      setOpen={setOpen}
      bodyshopService={bodyshopService}
      setBodyshopService={setBodyshopService}
      setBodyshopServiceVersion={setBodyshopServiceVersion}
      aeService={aeService}
      setAeService={setAeService}
      reload={reload}
      setReload={setReload}
      parts={parts}
      setParts={setParts}
      showBudgetItems={showBudgetItems}
      onRemove={onRemove}
      onRemovePiece={onRemovePiece}
      onRemoveService={onRemoveService}
      onRemoveAeService={onRemoveAeService}
      hvTable={hvTable}
      createOption={createOption}
      deleteOptions={deleteOptions}
      changeValueAeService={changeValueAeService}
      // origins={origins}
      // createOrigin={createOrigin}
    />
  );
};

export default ModalBudgetContainer;

const dateWithoutTimezone = (date) => {
  const tzoffset = date.getTimezoneOffset() * 60000; //offset in milliseconds
  const withoutTimezone = new Date(date.valueOf() - tzoffset)
    .toISOString()
    .slice(0, -1);
  return withoutTimezone;
};
